import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { groupBy, map, mergeMap, reduce, startWith, switchMap, toArray } from 'rxjs/operators';
import { ILookupValue } from '../app/models/lookupvalues';
import { removeDiacritics } from './utils';

export interface ILookupCategory {
  category: string;
  value: ILookupValue;
}

export interface LookupGroup {
  letter: string;
  values: ILookupValue[];
}

export const filterValues = (opt: ILookupValue[], value: string): ILookupValue[] => {
  if (value.length > 1) {
    const filterValue = removeDiacritics(value).toLowerCase();
    return opt.filter(x => removeDiacritics(x.Value).toLowerCase().includes(filterValue));
  }
  return opt;
};

export const filterCategoryGroup = (opt: Observable<ILookupCategory>, value: string): Observable<LookupGroup[]> => {
  const valueGroups = opt.pipe(
    groupBy(value => value.category),
    mergeMap(group => group
      .pipe(
        reduce((acc, cur) => {
          acc.values.push(cur.value);
          return acc;
        }, { letter: group.key, values: [] })
      )
    ),
    toArray()
  );
  if (value) {
    return valueGroups.pipe(
      map(group => group.map(group => ({ letter: group.letter, values: filterValues(group.values, value) }))
        .filter(group => group.values.length > 0))
    );
  }
  return valueGroups;
};

export const valueGroupOptions = (opt: Observable<ILookupCategory>, control: AbstractControl): Observable<LookupGroup[]> => {
  return control.valueChanges.pipe(
    map(value => typeof value === 'string' ? value : value?.Value),
    startWith(''),
    switchMap(value => filterCategoryGroup(opt, value))
  );
};
